import api from './index'

let exports = {};
//
exports.getServcReqVoucherDocList = function (data, callback) {// 通过服务订单id获取服务工单列表
    api.post('/servcDispt/shop/deliv/req/voucher/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存服务请求单-安装
exports.saveServcReqVoucherForSetup = function (data, callback) {
    api.post('/servcDispt/servc/req/voucher/setup/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcDispt.js
// module id = 321
// module chunks = 0